import { useState, useEffect, useRef, useCallback } from "react";
import CondIcon from "../assets/conductor-icon-2.png";
import DataTable from "react-data-table-component";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import DutyPostingService from "../services/dutyposting,service";

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(null, args);
    }, delay);
  };
};

const DutyList = () => {
  const [checked, setChecked] = useState("present");
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [crewData, setCrewData] = useState([]);
  const [drvList, setDrvList] = useState([]);
  const [condList, setCondList] = useState([]);
  const [filter2, setFilter2] = useState(false);
  const [filteredDataDrv, setFilteredDataDrv] = useState([]);
  const [filteredDataCond, setFilteredDataCond] = useState([]);
  const [editDutyNo, setEditDutyNo] = useState(null);
  const [show, setShow] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);
  const [show6, setShow6] = useState(false);
  const [edit, setEdit] = useState();
  const [dutyLists, setDutyLists] = useState([]);
  const [busList, setBusList] = useState([]);
  const [showBusList, setShowBusList] = useState(false);
  const [dutyData, setDutyData] = useState({});
  const [selectedDrv, setSelectedDrv] = useState("");
  const [selectedCon, setSelectedCon] = useState("");

  const onDragStartCon = (event, conId, isPresent, type) => {
    event.dataTransfer.setData("draggedItemIndex", conId);
    event.dataTransfer.setData("draggedItemIndexPresent", isPresent);
    event.dataTransfer.setData("draggedItemIndexType", type);
    // console.log(event, conId);
  };

  const onDropCon = (event, dropIndex) => {
    const draggedItemIndex = event.dataTransfer.getData("draggedItemIndex");
    const draggedItemIndexPresent = event.dataTransfer.getData(
      "draggedItemIndexPresent"
    );
    const draggedItemIndexType = event.dataTransfer.getData(
      "draggedItemIndexType"
    );
    // console.log(draggedItemIndex, dropIndex);
    if (draggedItemIndexType === "cond") {
      if (draggedItemIndexPresent === "1") {
        setShow3(true);
        setSelectedCon(draggedItemIndex);
        setDutyData(dropIndex);
      } else {
        toast.warn("Conductor is not Available!", {
          position: "top-center",
          // autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      // alert("Driver Selected");
      toast.warn("Please select Conductor!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const onDragStartDrv = (event, drvId, isPresent, type) => {
    event.dataTransfer.setData("draggedItemIndex2", drvId);
    event.dataTransfer.setData("draggedItemIndexPresent2", isPresent);
    event.dataTransfer.setData("draggedItemIndexType2", type);
    // console.log(event, drvId);
  };

  const onDropDrv = (event, dropIndex) => {
    const draggedItemIndex = event.dataTransfer.getData("draggedItemIndex2");
    const draggedItemIndexPresent = event.dataTransfer.getData(
      "draggedItemIndexPresent2"
    );
    const draggedItemIndexType = event.dataTransfer.getData(
      "draggedItemIndexType2"
    );
    // console.log(draggedItemIndex, dropIndex);
    if (draggedItemIndexType === "drv") {
      if (draggedItemIndexPresent === "1") {
        setShow4(true);
        setSelectedDrv(draggedItemIndex);
        setDutyData(dropIndex);
      } else {
        toast.warn("Driver is not Available!", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      // alert("Conductor Selected");
      toast.warn("Please select Driver!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  // const onDragOver = (event) => {
  //   event.preventDefault();
  // };

  const fetchData = async () => {
    try {
      const response = await DutyPostingService.getAllocatedDuty();

      const result = await response.data;
      const filteredResult = result.map((item) => ({
        ...item,
        driverPresenty: "1",
        conductorPresenty: "1",
        delayReasonId: "9",
      }));
      setDutyLists(filteredResult);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData();
    let intervalId;
    if (!edit) {
      intervalId = setInterval(fetchData, 60000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [edit]);

  const columns = [
    {
      name: (
        <div className="theadcol-flex">
          <span>Duty No</span>
        </div>
      ),
      selector: (row) => row.dutyNo,
      sortable: true,
      width: "115px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Driver</span>
        </div>
      ),
      selector: (row) => row.driverNO,
      cell: (row, index) => (
        <div className="crew" onDrop={(event) => onDropDrv(event, row)}>
          <div className="crew-pic">
            <span>
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.4376 10.889C25.4376 15.8146 22.4622 20.0418 18.5001 20.0418C14.5349 20.0418 11.5626 15.8146 11.5626 10.8874C11.5626 5.96333 14.1218 3.0835 18.5001 3.0835C22.8784 3.0835 25.4376 5.96179 25.4376 10.889ZM6.32401 31.0524C6.91755 31.7585 9.47363 33.9168 18.5001 33.9168C27.5266 33.9168 30.0811 31.7585 30.6762 31.054C30.7314 30.9862 30.7722 30.908 30.796 30.8239C30.8199 30.7399 30.8263 30.6519 30.8149 30.5653C30.6793 29.2055 29.4552 23.1252 18.5001 23.1252C7.54501 23.1252 6.32093 29.2055 6.18372 30.5653C6.17255 30.652 6.17924 30.7401 6.20336 30.8241C6.22749 30.9081 6.26855 30.9848 6.32401 31.0524Z"
                  fill="#D2CDDA"
                />
              </svg>
            </span>
          </div>
          <div className="crew-info">
            <div className="other-info">
              <div className="crew-code">
                <div>
                  <strong>{row.driverNO}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Conductor </span>
        </div>
      ),
      selector: (row) => row.conductorNo,
      cell: (row, index) => (
        <div className="crew" onDrop={(event) => onDropCon(event, row)}>
          <div className="crew-pic">
            <span>
              <svg
                width="37"
                height="37"
                viewBox="0 0 37 37"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.4376 10.889C25.4376 15.8146 22.4622 20.0418 18.5001 20.0418C14.5349 20.0418 11.5626 15.8146 11.5626 10.8874C11.5626 5.96333 14.1218 3.0835 18.5001 3.0835C22.8784 3.0835 25.4376 5.96179 25.4376 10.889ZM6.32401 31.0524C6.91755 31.7585 9.47363 33.9168 18.5001 33.9168C27.5266 33.9168 30.0811 31.7585 30.6762 31.054C30.7314 30.9862 30.7722 30.908 30.796 30.8239C30.8199 30.7399 30.8263 30.6519 30.8149 30.5653C30.6793 29.2055 29.4552 23.1252 18.5001 23.1252C7.54501 23.1252 6.32093 29.2055 6.18372 30.5653C6.17255 30.652 6.17924 30.7401 6.20336 30.8241C6.22749 30.9081 6.26855 30.9848 6.32401 31.0524Z"
                  fill="#D2CDDA"
                />
              </svg>
            </span>
          </div>
          <div className="crew-info">
            <div className="other-info">
              <div className="crew-code">
                <div>
                  <strong>{row.conductorNo}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Vehicle No.</span>
        </div>
      ),
      selector: (row) => row.busNo,
      cell: (row, index) => (
        <>
          <div className="busno">
            <span>{row.busNo}</span>
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Delay Reason</span>
        </div>
      ),
      selector: (row) => row.delayReasonId,
      cell: (row, index) => (
        <>
          <div className="busno">
            <span>{row.delayReason}</span>
          </div>
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Start Time</span>
        </div>
      ),
      selector: (row) => row.timeTo,
      cell: (row) => (
        <>
          <div className="">{parseFloat(row.timeTo).toFixed(2)}</div>
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Allocated Time</span>
        </div>
      ),
      selector: (row) => row.onBusTime,
      cell: (row) => (
        <>
          <div className="">{row.transactiondate}</div>
        </>
      ),
      sortable: true,
    },
  ];

  const conditionalRowStyles = [
    {
      when: (row) => String(row.dutyAllot) === "1",
      style: {
        backgroundColor: "#93D5A0 !important",
      },
    },
  ];

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();
    // const data = allocatedDuty;
    const filteredData = dutyLists.filter(
      (row) =>
        (row.dutyNo &&
          row.dutyNo.replace(/\s+/g, "").toLowerCase() === keyword) ||
        (row.conductorNo &&
          row.conductorNo.replace(/\s+/g, "").toLowerCase() === keyword) ||
        (row.driverNO &&
          row.driverNO.replace(/\s+/g, "").toLowerCase() === keyword) ||
        (row.busNo && row.busNo.toLowerCase().includes(keyword))
      // (row.timeTo && row.timeTo.toLowerCase() === keyword)
    );

    console.log(dutyLists, filteredData, keyword);

    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  return (
    <>
      <ToastContainer />
      <div className="search-bar">
        <input
          type="text"
          placeholder="Click here to Search by Duty No./bus no./Driver or Conductor Code."
          name="search"
          value={search}
          onChange={handleSearch}
        />
        <div className="search-icon">
          <span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                stroke="#A79EB7"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>
      </div>
      <div className="datatable">
        <DataTable
          columns={columns}
          data={filter ? filteredData : dutyLists}
          fixedHeader
          conditionalRowStyles={conditionalRowStyles}
        />
      </div>
    </>
  );
};
export default DutyList;
